import React from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";

const apiKey = "AIzaSyA1mKhKPSdwCX7Dq6od70Z3GuGZCZyNoLY";
const address = {
  lat: -33.441143,
  lng: -70.651093
};

const MapWithAMarker = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap defaultZoom={15} defaultCenter={address}>
      <Marker position={address} />
    </GoogleMap>
  ))
);

const MapaFinal = () => (
  <MapWithAMarker
    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=3.exp&libraries=geometry,drawing,places`}
    loadingElement={<div style={{ height: `100%` }} />}
    containerElement={<div style={{ height: `400px` }} />}
    mapElement={<div style={{ height: `100%` }} />}
  />
);

export default MapaFinal;
